import React from 'react';
import { StyledButton, StyledContainer, StyledInput, StyledLabel, StyledOuterContainer, StyledIcon } from './index.styles.js';
import {} from '../icon/icon-names.generated.js';
import { Icon } from '../icon/index.js';
import {} from '@oneaudi/unified-web-common';
import { Popover } from '../popover/index.js';
export const Tag = ({ id, label, variant, onClick, 'aria-label': ariaLabel, icon, className, size, popover, name, defaultChecked, onChange, checked, value, disabled, 'data-testid': dataTestId, margin }) => {
    const iconSize = size == 'md' ? 's' : 'xs';
    if (variant === 'read-only') {
        return (React.createElement(StyledContainer, { size: size, className: className, variant: variant, "data-testid": dataTestId, margin: margin },
            icon && React.createElement(Icon, { size: iconSize, name: icon }),
            label));
    }
    if (variant === 'removable') {
        return (React.createElement(StyledContainer, { size: size, className: className, variant: variant, "data-testid": dataTestId, margin: margin },
            label,
            React.createElement(StyledButton, { onClick: onClick, "aria-label": ariaLabel },
                React.createElement(StyledIcon, { size: iconSize, name: "cancel" }))));
    }
    if (variant === 'offer') {
        const getIcon = size === 'md' ? 'special-offer-active' : 'special-offer';
        if (popover) {
            return (React.createElement(StyledOuterContainer, { size: size },
                React.createElement(StyledContainer, null,
                    React.createElement(StyledIcon, { size: iconSize, name: getIcon }),
                    label),
                React.createElement(Popover, { alignment: popover.alignment, withTip: popover.withTip, open: popover.open, onClose: popover.onClose, content: popover.content, id: popover.id, triggerElement: React.createElement(StyledButton, { onClick: popover.onTriggerClick, "aria-label": popover.triggerAriaLabel },
                        React.createElement(StyledIcon, { name: "info-circle", size: iconSize })) })));
        }
        return (React.createElement(StyledContainer, null,
            React.createElement(Icon, { size: iconSize, name: getIcon }),
            label));
    }
    const getIcon = () => {
        if (icon) {
            return React.createElement(Icon, { size: iconSize, name: checked ? 'select' : icon });
        }
        if (checked) {
            return React.createElement(Icon, { size: iconSize, name: 'select' });
        }
        return;
    };
    return (React.createElement(StyledLabel, { className: className, "data-testid": dataTestId, margin: margin },
        React.createElement(StyledContainer, { variant: variant, size: size, disabled: disabled },
            React.createElement(StyledInput, { value: value, type: "checkbox", name: name, defaultChecked: defaultChecked, onChange: onChange, onClick: onClick, checked: checked, disabled: disabled, id: id }),
            getIcon(),
            label)));
};
//# sourceMappingURL=index.js.map